import { linkDomainOptions, PromotionRelatedGridModel, PurchaseLinkOrdersGridModel } from "./PurchaseLinkModels";
 

export class CheckoutMainDetailPageModel {
  selectedSharingType: string;
  createdBy: string;
  createdDate: string;
  isLinkEditing: boolean;
  linkDomain: string;
  linkPath: string;
  promoCodes: PromotionRelatedGridModel[];
  orders: PurchaseLinkOrdersGridModel[];
  name: string;

  constructor(data?: Partial<CheckoutMainDetailPageModel>) {
      this.selectedSharingType = data?.selectedSharingType || 'Link';
      this.createdBy = data?.createdBy || 'Jeff Cohen';
      this.createdDate = data?.createdDate || '20-08-2024';
      this.promoCodes = (data?.promoCodes || []).map((promotion) => new PromotionRelatedGridModel(promotion));
      this.orders = (data?.orders || []).map((order) => new PurchaseLinkOrdersGridModel(order));
      this.isLinkEditing = data?.isLinkEditing || false;
      this.linkDomain = data?.linkDomain || linkDomainOptions[0].value;
      this.linkPath = data?.linkPath || '';
      this.name = data?.name || '';
  }
}